export default function registerCookieConsent(Alpine) {
  Alpine.data("cookieConsent", () => ({
    visible: !localStorage.getItem("cookie_consent"),

    acceptAll() {
      localStorage.setItem("cookie_consent", "all");
      this.updateConsent("granted");
      this.visible = false;
    },

    acceptRequired() {
      localStorage.setItem("cookie_consent", "required");
      this.updateConsent("denied");
      this.visible = false;
    },

    updateConsent(state) {
      if (typeof window.gtag === "function") {
        window.gtag("consent", "update", {
          ad_storage: state,
          ad_user_data: state,
          ad_personalization: state,
          analytics_storage: state
        });
      }
    }
  }));
}
